// import Rails from "@rails/ujs";
// Rails.start();
// import { Turbo } from "@hotwired/turbo-rails";
// window.Turbo = Turbo;

export const initApp = async () => {
  if (!window.Turbo) {
    const Rails = require("@rails/ujs");
    Rails.start();

    const Turbo = require("@hotwired/turbo-rails");

    // await Turbo.start();
    window.Turbo = Turbo;
  }

  return window.Turbo;
}

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

const images = require.context('../images', true);
const imagePath = (name) => images(name, true);

// styles
import "../styles/normalize.css";
import "../styles/common.scss";

window.debounce = function(func, wait = 100) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

document.addEventListener("DOMContentLoaded", function() {
  initApp();
});
